<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收费方案详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-scheme-detail">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span v-if="schemeid">{{ $route.meta.title }}</span>
        <span v-else>收费方案添加</span>
      </div>
      <div class="toolbox">
        <el-button v-if="schemeid" type="danger" plain @click="deletePlan">删除</el-button>
      </div>
    </div>
    <el-card shadow="never">
      <div style="display: flex;">
        <div class="preview">
          <div class="header">
            <span>方案示例</span>
          </div>
          <div class="body" :style="{backgroundImage: `url(${require(!profile.activity_enable || (!in_activity && !basicFormShow) ? '../../assets/scheme-default.jpg' : '../../assets/scheme-ladder.jpg')})`}">
            <div v-if="!profile.activity_enable || (!in_activity && !basicFormShow)" class="price_ladder">
              <div v-for="item in 3" class="ladder_item">
                <div class="flex column justify-content-center mt-lg">
                  <div class style="font-size: 16px;">{{ item + '年' }}</div>
                  <div class="mt-sm discount-price ellipsis">
                    ￥{{ profile.scheme_price ? +(profile.scheme_price * item).toFixed(2) : '--' }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="!profile.activity_params.advanced_price_enable && profile.activity_enable" class="price_ladder">
              <div v-for="item in 3" class="ladder_item">
                <div class="flex column justify-content-center mt-sm">
                  <div class style="font-size: 16px;">{{ item + '年' }}</div>
                  <div class="mt-sm discount-price ellipsis">
                    <span v-if="profile.activity_params.discount_price">￥{{ +(profile.activity_params.discount_price * item).toFixed(2) || '--' }}</span>
                    <span v-else-if="profile.activity_params.discount_price == 0">--</span>
                  </div>
                  <div
                    v-if="profile.scheme_price > profile.activity_params.discount_price"
                    class="text-muted line-though"
                    style="font-size: 11px;"
                  >￥{{ +(profile.scheme_price * item).toFixed(2) }}</div>
                </div>

                <div v-if="profile.scheme_price > profile.activity_params.discount_price" class="save ellipsis mt-sm">
                  已优惠<span class>￥{{ +((profile.scheme_price - profile.activity_params.discount_price) * item).toFixed(2) }}</span>
                </div>
                <div v-else class="save ellipsis mt-sm">无优惠</div>
              </div>
            </div>
            <div v-else-if="profile.activity_params.advanced_price_enable" class="price_ladder">
              <div class="ladder_item">
                <div class="flex column justify-content-center mt-sm">
                  <div class style="font-size: 16px;">{{ '1年' }}</div>
                  <div class="mt-sm discount-price ellipsis">
                    <span v-if="profile.activity_params.advanced_prices.one_year">￥{{ +(profile.activity_params.advanced_prices.one_year).toFixed(2) || '--' }}</span>
                    <span v-else-if="profile.activity_params.advanced_prices.one_year == 0">--</span>
                  </div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ +(profile.scheme_price).toFixed(2) }}</div>
                </div>
                <div v-if="profile.activity_params.advanced_prices.one_year < profile.scheme_price" class="save ellipsis mt-sm">
                  已优惠<span class>￥{{ +(profile.scheme_price - profile.activity_params.advanced_prices.one_year).toFixed(2) }}</span>
                </div>
                <div v-else class="save ellipsis mt-sm">
                  无优惠
                </div>
              </div>
              <div class="ladder_item">
                <div class="flex column justify-content-center mt-sm">
                  <div class style="font-size: 16px;">{{ '2年' }}</div>
                  <div class="mt-sm discount-price ellipsis">
                    <span v-if="profile.activity_params.advanced_prices.two_year">￥{{ +(profile.activity_params.advanced_prices.two_year * 2).toFixed(2) || '--' }}</span>
                    <span v-else-if="profile.activity_params.advanced_prices.two_year == 0">--</span>
                  </div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ +(profile.scheme_price * 2).toFixed(2) }}</div>
                  <div v-if="profile.activity_params.advanced_prices.two_year < profile.scheme_price" class="save ellipsis mt-sm">
                    已优惠<span class>￥{{ +((profile.scheme_price - profile.activity_params.advanced_prices.two_year) * 2 ).toFixed(2) }}</span>
                  </div>
                  <div v-else class="save ellipsis mt-sm">
                    无优惠
                  </div>
                </div>
              </div>
              <div class="ladder_item">
                <div class="flex column justify-content-center mt-sm">
                  <div class style="font-size: 16px;">{{ '3年' }}</div>
                  <div class="mt-sm discount-price ellipsis">
                    <span v-if="profile.activity_params.advanced_prices.three_year">￥{{ +(profile.activity_params.advanced_prices.three_year * 3).toFixed(2) || '--' }}</span>
                    <span v-else-if="profile.activity_params.advanced_prices.three_year == 0">--</span>
                  </div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ +(profile.scheme_price * 3).toFixed(2) }}</div>
                </div>
                <div v-if="profile.activity_params.advanced_prices.three_year < profile.scheme_price" class="save ellipsis mt-sm">
                  已优惠<span class>￥{{ +((profile.scheme_price - profile.activity_params.advanced_prices.three_year) * 3).toFixed(2) }}</span>
                </div>
                <div v-else class="save ellipsis mt-sm">
                  无优惠
                </div>
              </div>
            </div>

            <div class="other-price">
              <div class="flex align-items-center mb-xs">
                <i class="el-icon-warning text-blue"></i>
                <span class="font-sm ml-xs">含物联卡复机一次性费用</span>
              </div>
              <div class="flex align-items-center">
                <i class="el-icon-warning text-blue"></i>
                <span class="font-sm ml-xs">含厂家服务费用</span>
              </div>
            </div>

            <div v-if="!profile.activity_enable || (profile.activity_enable && !advance_show)" class="total">
              <span style="font-size:16px">应付：</span>
              <span style="font-size: 28px;color: #07c160;">￥{{ profile.scheme_price }}</span>
            </div>
            <div v-else class="total2">
              <div>
                <span style="font-size:16px">应付：</span>
                <span style="font-size: 28px;color: #07c160;">￥{{ profile.activity_params.discount_price }}</span>
              </div>
              <div style="font-size:14px;color:rgba(194, 91, 96, 1)">
                <span>共减</span>
                <span class="ml">￥{{ (profile.scheme_price - profile.activity_params.discount_price).toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: auto;">
          <el-tabs v-model="activeTab" type="card">
            <el-tab-pane label="基本信息" name="basic">
              <basic
                :type="type"
                @show="formShow"
                @change="changeBasic"
                @update="updateSchemeid"
                :plat_promotion_enable="profile.plat_promotion_enable"
                :recommendProfile="recommendProfile"
              />
            </el-tab-pane>
            <el-tab-pane v-if="schemeid" label="通知设置" name="notice">
              <notice />
            </el-tab-pane>
            <el-tab-pane v-if="schemeid" label="数据分析" name="statistic">
              <DataStatistic />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-card>

    <clause :show.sync="newScheme" :iscreate="true" :plat_promotion_enable="true" @submit="handleSubmit" />
    <ei-scheme-recommend :show.sync="recommend" @submit="handleRecommend"/>
  </div>
</template>

<script>
import { getSchemeDetailApi, delSchemeApi } from "@/api/ei/eiApi";

export default {
  name: "EiSchemeDetail",

  components: {
    Basic: () => import("@/views/ei/components/EiSchemeBasic"),
    Notice: () => import("@/views/ei/components/EiSchemeNotice"),
    DataStatistic: () => import("@/views/ei/components/DataStatistic"),
    Clause: () => import("./components/EiClause"),
    EiSchemeRecommend: () => import("./components/EiSchemeRecommend"),
  },

  data() {
    return {
      basicFormShow: false,
      schemeid: this.$route.query.schemeid
        ? parseInt(this.$route.query.schemeid)
        : undefined,
      type: this.$route.query.type ? parseInt(this.$route.query.type) : 0,
      activeTab: "basic",
      time: parseInt(new Date().valueOf() / 1000),
      profile: {
        title: "",
        scheme_unit: "year",
        scheme_price: 0,
        activity_enable: 0,
        activity_params: {
          advanced_prices: {
            one_year: 0,
            two_year: 0,
            three_year: 0,
          },
        },
      },

      newScheme: false,
      recommend: false,
      recommendProfile: {},
    };
  },

  computed: {
    god() {
      return this.$store.state.godStore;
    },

    superFastLogin() {
      return this.$store.state.userStore.superFastLogin;
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version;
    },

    advance_show() {
      return this.basicFormShow ||
        (!this.basicFormShow &&
          this.profile.activity_params.endtime &&
          this.time < this.profile.activity_params.endtime &&
          this.time > this.profile.activity_params.starttime)
        ? true
        : false;
    },

    in_activity() {
      return this.profile.activity_params.starttime
        ? this.time > this.profile.activity_params.starttime && this.time < this.profile.activity_params.endtime
        : false;
    }
  },

  watch: {
    advance_show(val) {
    }
  },

  created() {
    this.fetchData();
    if (this.schemeid == 0) {
      this.newScheme = true;
    }
  },

  methods: {
    fetchData() {
      if (!this.schemeid) {
        return;
      }
      getSchemeDetailApi({ schemeid: this.schemeid }).then((res) => {
        if (!res.errno) {
          if (
            res.data.profile.scheme_unit == "year" &&
            Object.keys(res.data.profile.activity_params).length == 0
          ) {
            const advanced_prices = {
              one_year: 0,
              two_year: 0,
              three_year: 0,
            };
            const activity_params = {};
            const temp1 = Object.assign(activity_params, { advanced_prices });
            this.profile = Object.assign({}, res.data.profile, {
              activity_params: temp1,
            });
          }
          this.profile.title = res.data.profile.title;
          this.profile.scheme_unit = res.data.profile.scheme_unit;
          this.profile.scheme_price = +res.data.profile.scheme_price;
          this.profile.activity_enable = res.data.profile.activity_enable;
          this.profile.activity_params = Object.assign(
            {},
            res.data.profile.activity_params
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    formShow(show) {
      this.basicFormShow = show;
    },
    updateSchemeid(id) {
      this.schemeid = id;
    },
    changeBasic(basic) {
      if (basic.unit == "year" && !basic.two_year) {
        const advanced_prices = {
          one_year: 0,
          two_year: 0,
          three_year: 0,
        };
        const activity_params = {};
        const temp1 = Object.assign(activity_params, { advanced_prices });
        this.profile = Object.assign({}, this.profile, { activity_params: temp1 });
      }
      this.profile.title = basic.title;
      this.profile.scheme_unit = basic.unit;
      this.profile.scheme_price = +basic.scheme_price;
      this.profile.activity_enable = basic.activity_enable;
      this.$set(this.profile.activity_params, "title", basic.name);
      this.$set(this.profile.activity_params, "starttime", basic.starttime);
      this.$set(this.profile.activity_params, "endtime", basic.endtime);
      this.$set(
        this.profile.activity_params,
        "discount_price",
        +basic.discount_price
      );
      this.$set(
        this.profile.activity_params,
        "advanced_price_enable",
        basic.advanced_price_enable
      );
      if (basic.unit == "year") {
        this.$set(
          this.profile.activity_params.advanced_prices,
          "one_year",
          +basic.discount_price
        );
        this.$set(
          this.profile.activity_params.advanced_prices,
          "two_year",
          +basic.two_year
        );
        this.$set(
          this.profile.activity_params.advanced_prices,
          "three_year",
          +basic.three_year
        );
      }
    },

    deletePlan() {
      if (!this.superFastLogin && this.aiot_version == 2) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      const msg = "此操作将永久删除该方案，是否继续?";
      this.$confirm(msg, "提示", {
        type: "warning",
      }).then(() => {
        delSchemeApi({ schemeid: this.schemeid }).then((res) => {
          if (res.errno === 0) {
            this.$message.success(res.message);
            this.$router.go(-1);
            return;
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    handleSubmit(e) {
      this.profile.plat_promotion_enable = e.plat_promotion_enable;
      this.recommend = true
    },
    handleRecommend(e) {
      if(e) {
        this.profile = Object.assign({},this.profile, e);
        this.recommendProfile = Object.assign({},this.profile);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ei-scheme-detail {
  .preview {
    width: 350px;
    margin: 0px 100px 40px 50px;
    .header {
      line-height: 40px;
      text-align: center;
    }
    .body {
      position: relative;
      width: 350px;
      height: 768px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      background-size: cover;
      background-repeat: no-repeat;
      .wechat {
        margin-top: 205px;
        margin-left: 30px;
        margin-right: 30px;
        // align-items: center;
        // justify-content: space-between;
        .title {
          font-weight: bold;
          line-height: 25px;
        }
      }
      .activityTitle {
        position: relative;
        right: -16px;
        top: -12px;
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        border-radius: 0px 10px 0px 10px;
        background: linear-gradient(to right, #ff7400, #ffae0c);
      }
      .deadline {
        margin-left: 30px;
        margin-top: 0px;
        font-size: 14px;
      }
      .promotion {
        margin-top: 10px;
        margin-left: 40px;
        margin-right: 30px;
        font-size: 14px;
      }
      .price {
        position: absolute;
        top: 325px;
        right: 30px;
        font-weight: bold;
        .originalPrice1 {
          text-decoration: line-through;
          font-size: 14px;
          opacity: 0.5;
          color: rgba(16, 16, 16, 1);
          margin-bottom: 5px;
        }
        .originalPrice2 {
          margin-top: 20px;
          font-size: 14px;
          line-height: 40px;
        }
        .discount {
          vertical-align: baseline;
        }
      }
      .price_ladder {
        position: absolute;
        display: flex;
        top: 243px;
        right: 15px;
        width: 320px;
        height: 115px;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 16px;
        .ladder_item {
          width: 85px;
          text-align: center;
          position: relative;
          .discount-price {
            font-size: 18px;
            height: 25px;
            line-height: 25px;
            text-align: center;
          }
          .line-though {
            text-decoration: line-through;
          }
          .save {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 5px;
            padding: 0 2px;
            font-size: 12px;
            color: #12c467;
          }
          .ladder_foot {
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 30px;
            background-color: #fff;
            border-radius: 0 0 5px 5px;
          }
        }
        .ladder_item:first-child {
          margin-left: 0;
        }
        .ladder_item:last-child {
          margin-right: 0;
        }
      }
      .other-price {
        position: absolute;
        top: 365px;
        left: 30px;
      }
      .total {
        position: absolute;
        bottom: 15px;
        left: 20px;
      }
      .total2 {
        position: absolute;
        bottom: 5px;
        left: 20px;
      }
    }
    .el-scrollbar {
      height: 508px;
      > .el-scrollbar__wrap {
        overflow-x: hidden;
        > .el-scrollbar__view {
          padding: 0 0 0 0;
        }
      }
    }
  }
}
</style>
